package fr.frux.shared.domain.onboarding

import fr.frux.core.common.di.AppScope
import fr.frux.core.common.prefs.AppPreferences
import dev.zacsweers.metro.Inject
import dev.zacsweers.metro.SingleIn

/**
 * Persists whether the user has completed onboarding (seen the Welcome
 * screen and moved on, or authenticated). Once completed, the app never
 * shows Welcome again.
 */
@SingleIn(AppScope::class)
@Inject
class OnboardingStore(
    private val preferences: AppPreferences
) {

    suspend fun isCompleted(): Boolean =
        preferences.getBoolean(KEY_ONBOARDING_COMPLETED)

    suspend fun markCompleted() {
        preferences.putBoolean(KEY_ONBOARDING_COMPLETED, true)
    }

    companion object {
        private const val KEY_ONBOARDING_COMPLETED = "onboarding_completed"
    }
}
